import { createAction } from '@reduxjs/toolkit';

export const PROCESS_AGENT_STATUS_ACTION_TYPE = 'saga/processAgentStatus';
export const processAgentStatusAction = createAction(PROCESS_AGENT_STATUS_ACTION_TYPE);
